'use strict';
const kdContextError = require('./kd-context');

/**
 * Validation Error
 *
 * This error denotes a Validation Error, usually thrown after applying
 * a AJV validator to data with a JSON-schema.
 *
 * If `context` is provided, it should be the return value from
 * [`AJV.validator()`]{@link
 * https://github.com/epoberezkin/ajv}
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} context - AJV validation details
 * @param {Boolean} context.valid - (should be false if thrown!)
 * @param {Array} context.errors - Array of validator error objects:
 * @param {string} context.errors.code - Usually equal to the schema
 *                                    attribute (`required`, `minimum`)
 * @param {string} context.errors.message - default or custom message, e.g
 *                                      "Must be a valid UUID"
 * @param {*} [context.errors.arg] - For bound violation errors, this is
 *                                the value of the violated boundary as
 *                                defined in the schema. e.g.`maximum`
 *                                value of an integer
 * @param {*} context.errors.value - Value that violated the schema
 * @param {Array} context.errors.path - Array of properties used to get
 *                                   the invalid value from root of the
 *                                   validation `context`
 */
class ValidationError extends kdContextError {
    constructor(message, detail, context) {
        super(message, detail, context);
        this.name = 'ValidationError';
        this.status = 400;
    }
}

module.exports = ValidationError;



/** WEBPACK FOOTER **
 ** ./src/common/error/validation.js
 **/